import React, {
  useImperativeHandle,
  useState,
  forwardRef,
  useEffect,
} from "react";
import axios from "axios";
import { Form, Modal, Select, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getRelevanceCompany } from "../../../api/api";
import { request } from "../../../utils/fetch"; // 假设你的 request 工具
import { name } from "file-loader";

const { Option } = Select;

const ImportModal = (props, ref) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [companyCodeList, setCompanyCodeList] = useState([]);
  const [uploading, setUploading] = useState(false);

  // 暴露方法给父组件
  useImperativeHandle(ref, () => ({
    showModal: () => {
      setVisible(true);
      setFileList([]);
      form.resetFields();
    },
    hideModal: () => setVisible(false),
  }));

  useEffect(() => {
    getRelevanceCompanyAll();
  }, []);

  // 获取所有企业
  const getRelevanceCompanyAll = async () => {
    const res = await getRelevanceCompany();
    if (res) {
      setCompanyCodeList(res);
    }
  };

  // 确认上传
  const handleOk = async () => {
    // 校验表单
    const values = await form.validateFields();

    if (fileList.length === 0) {
      message.error("请选择要上传的文件");
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", fileList[0].originFileObj);
      formData.append("companyCode", values.companyCode); // 添加企业参数
      const obj = {};
      formData.forEach((value, key) => {
        obj[key] = value;
      });
      const { data: res } = await request.requestFormDataPost(
        "/platform/staffOrder/importOrder",
        obj
      );
      if (!res.success) return message.error(res.retMsg);

      message.success("导入成功");
      setVisible(false);
      setFileList([]);
      form.resetFields();

      // 通知父组件刷新列表
      if (props.onSuccess) {
        props.onSuccess();
      }
    } catch (error) {
      message.error(error.message || "导入失败");
    } finally {
      setUploading(false);
    }
  };

  // 取消/关闭
  const handleCancel = () => {
    setVisible(false);
    setFileList([]);
    form.resetFields();
  };

  // 上传配置 - 限制单个文件
  const uploadProps = {
    name: "file",
    accept: ".xlsx,.xls", // 限制 Excel 格式
    fileList,
    maxCount: 1, // 最多 1 个文件
    beforeUpload: (file) => {
      setFileList([file]);
      return false; // 阻止自动上传
    },
    onRemove: () => {
      setFileList([]);
    },

    onChange: (info) => {
      // 限制只有一个文件
      let fileCon = [...info.fileList];
      setFileList(fileCon.slice(-1));
    },
  };

  // 下载模板
  const downloadTemplate = () => {
    request.downloadTemplate("/common/getTemplateDownloadUrl", {
      type: "XMDD_DR",
    });
  };

  return (
    <Modal
      title="导入"
      forceRender
      visible={visible}
      width={600}
      confirmLoading={uploading}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="确认导入"
      cancelText="取消"
      maskClosable={false} // 防止误点关闭
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        autoComplete="off"
      >
        <Form.Item
          label="企业名称"
          name="companyCode"
          rules={[{ required: true, message: "请选择企业" }]}
        >
          <Select
            allowClear
            placeholder="请选择企业"
            showSearch
            optionFilterProp="children"
          >
            {companyCodeList.map((e) => (
              <Option key={e.companyCode} value={e.companyCode}>
                {e.companyName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="明细文件"
          name="file"
          required // 标记必填，但不设置 rules，因为 Upload 在 Form 外控制
        >
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>选择文件</Button>
          </Upload>
          {fileList.length > 0 && (
            <span style={{ marginLeft: 8, color: "#52c41a" }}>
              已选择: {fileList[0].name}
            </span>
          )}
          <div style={{ marginTop: 8 }}>
            <Button type="link" onClick={downloadTemplate}>
              下载模板
            </Button>
            <span style={{ color: "#999", marginLeft: 16 }}>
              仅支持 .xlsx, .xls 格式，最大 10MB
            </span>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default forwardRef(ImportModal);
